import { render, staticRenderFns } from "./PrintableForms.vue?vue&type=template&id=520c0800&scoped=true"
import script from "./PrintableForms.vue?vue&type=script&lang=js"
export * from "./PrintableForms.vue?vue&type=script&lang=js"
import style0 from "./PrintableForms.vue?vue&type=style&index=0&id=520c0800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c0800",
  null
  
)

export default component.exports